import { CustomPersonCredentialApplicationStatusDefinition } from './customPersonCredentialApplicationStatusDefinition.model';
import { CredentialStatusLabelColor } from './customPersonCredentialStatusDefinition.model';
import { PersonCredentialScenario } from './personCredentialScenario';
import { EntityCredentialSpecialty } from './entityCredentialSpecialty';
import { EntityCredentialPayment } from './entityCredentialPayment';
import { CredentialApplicationDefinitionType } from './CredentialApplicationDefinitionType';

export class EntityCredentialApplication {
  public id: string;
  public credentialApplicationDefinitionId: string;
  public entityId: string;
  public credentialName: string;
  public entityName: string;
  public entityCredentialId: string;
  public name: string;
  public credentialApplicationStartDate: Date;
  public credentialApplicationEndDate: Date;
  public applicationNumber: string;
  public credentialDefinitionId: string;
  public credentialScenarios: PersonCredentialScenario[] = [];
  public credentialSpecialties: EntityCredentialSpecialty[] = [];
  public status: CredentialApplicationStatus;
  public credentialCustomApplicationStatusDefinitionModel: CustomPersonCredentialApplicationStatusDefinition;

  constructor(
    id: string,
    credentialApplicationDefinitionId: string,
    entityId: string,
    credentialName: string,
    entityName: string,
    entityCredentialId: string,
    name: string,
    credentialApplicationStartDate: Date,
    credentialApplicationEndDate: Date,
    applicationNumber: string,
    credentialDefinitionId: string,
    credentialScenarios: PersonCredentialScenario[],
    credentialSpecialties: EntityCredentialSpecialty[],
    status: CredentialApplicationStatus,
    public credentialPayments: EntityCredentialPayment[],
    public type: CredentialApplicationDefinitionType,
    credentialCustomApplicationStatusDefinitionModel: CustomPersonCredentialApplicationStatusDefinition
  ) {
    this.id = id;
    this.credentialApplicationDefinitionId = credentialApplicationDefinitionId;
    this.entityId = entityId;
    this.credentialName = credentialName;
    this.entityName = entityName;
    this.entityCredentialId = entityCredentialId;
    this.name = name;
    this.credentialApplicationStartDate = credentialApplicationStartDate;
    this.credentialApplicationEndDate = credentialApplicationEndDate;
    this.applicationNumber = applicationNumber;
    this.credentialDefinitionId = credentialDefinitionId;
    this.credentialScenarios = credentialScenarios
      ? credentialScenarios.map((x) => PersonCredentialScenario.parse(x))
      : [];
    this.credentialSpecialties = credentialSpecialties ? credentialSpecialties : [];
    this.status = status;
    this.credentialCustomApplicationStatusDefinitionModel =
      credentialCustomApplicationStatusDefinitionModel;
  }

  static parse(obj: any): EntityCredentialApplication {
    if (obj == null) return null;
    return new EntityCredentialApplication(
      obj.id,
      obj.credentialApplicationDefinitionId,
      obj.entityId,
      obj.credentialName,
      obj.entityName,
      obj.entityCredentialId,
      obj.name,
      obj.credentialApplicationStartDate,
      obj.credentialApplicationEndDate,
      obj.applicationNumber,
      obj.credentialDefinitionId,
      obj.credentialScenarios,
      obj.credentialSpecialties,
      obj.status,
      obj.credentialPayments,
      obj.type,
      obj.credentialCustomApplicationStatusDefinitionModel
    );
  }

  public getStatusColor(): CredentialStatusLabelColor {
    if (this.credentialCustomApplicationStatusDefinitionModel?.color != null) {
      return this.credentialCustomApplicationStatusDefinitionModel.color;
    }
    switch (this.status) {
      case CredentialApplicationStatus.InProgress:
      case CredentialApplicationStatus.Completed:
        return CredentialStatusLabelColor.Green;
      case CredentialApplicationStatus.Archived:
        return CredentialStatusLabelColor.Gray;
    }
  }

  public getStatusText(): string {
    if (this.credentialCustomApplicationStatusDefinitionModel?.label != null) {
      return this.credentialCustomApplicationStatusDefinitionModel.label;
    }

    switch (this.status) {
      case CredentialApplicationStatus.InProgress:
        return 'In Progress';
      case CredentialApplicationStatus.Completed:
        return 'Completed';
      case CredentialApplicationStatus.Archived:
        return 'Archived';
    }
  }
}

export enum CredentialApplicationStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Archived = 'Archived',
}
